export default {
    titulo: "Usuarios",
    nuevo: "Nuevo usuario",
    editar: "Editar usuario",
    descatalogar: "Descatalogar usuario",
    pregDescatalogar: "¿Confirmas que deseas descatalogar el usuario?",
    descatalogados: "Descatalogados",
    restaurar: "Restaurar usuario",
    pregRestaurar: "¿Confirmas que deseas restaurar el usuario?",
    admin: "Administrador",
    cambiarPass: "Cambiar contraseña",
    comision: "Comisión",
    verSucursales: "Ver todas las sucursales",
    verSusOrdenes: "Ver solo sus órdenes",
    verReclamos: "Ver reclamos",
    verCosto: "Ver costo por obra",
    esProveedor: "Es proveedor",
    esGestor: "Es gestor",
    editarTodas: "Editar las órdenes de otras sucursales",
    esAdmin: "Es administrador de la cuenta",
    labelGrupos: "Grupos",
    msgErrorLimitePlan: "No se puede ingresar más usuarios porque excede el plan contratado",
    grupos: {
        titulo: "Grupos de usuarios",
        nuevo: "Nuevo grupo",
        editar: "Editar grupo",
        eliminar: "Eliminar grupo",
        pregEliminar: "¿Confirmas que deseas eliminar el grupo de usuarios?"
    },
    permisos: {
        label: "Permisos",
        Presupuesto: "Presupuesto",
        "Mano de Obra": "Mano de Obra",
        Repuestos: "Repuestos",
        "Eliminar Notas": "Eliminar Notas",
        "Ver Órdenes": "Ver Órdenes",
        "Ver Proveedores": "Ver Proveedores",
        "Ver Informes": "Ver Informes",
        "Eliminar Ordenes": "Eliminar Ordenes",
        "Eliminar Despachos": "Eliminar Despachos",
        "Modificar Despachos": "Modificar Despachos"

    }
}